import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import api from "../lib/api";
import { MapPin, Clock, Plane, Store } from "lucide-react";

const CRED = [
  ["14", "branches across the UAE"],
  ["4", "airport desks, open 24/7"],
  ["09:00–21:00", "doorstep delivery, daily"],
  ["800 EUROPCAR", "one number, any hour"],
];

export default function Network() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/branches").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#fafcfa]">
      <Header />
      <div className="bg-[#144733]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 promo-stripe">
          <h1 className="heading-upper text-2xl sm:text-3xl text-white" data-testid="network-heading">{t("Our network & branches")}</h1>
          <p className="text-white/80 text-sm mt-2 max-w-xl">{t("From the arrivals hall at DXB to the corniche in Fujairah, wherever you land, we're already there.")}</p>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-10 grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="credibility-strip">
          {CRED.map(([big, small]) => (
            <div key={small} className="bg-white/10 border border-white/15 rounded-xl p-4">
              <div className="text-xl font-bold text-[#FFDC00]">{big}</div>
              <div className="text-xs text-white/75 mt-1">{t(small)}</div>
            </div>
          ))}
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-10 w-full flex-1 space-y-10">
        {data?.groups.map((g) => (
          <section key={g.emirate} data-testid={`network-group-${g.emirate.toLowerCase().replace(/ /g, "-")}`}>
            <div className="promo-stripe mb-5">
              <h2 className="heading-upper text-xl text-[#144733]">{t(g.emirate)}</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {g.stations.map((s) => (
                <div key={s.id} className="bg-white rounded-2xl border border-[#E2E8F0] p-5 card-lift" data-testid={`branch-card-${s.id}`}>
                  <div className="flex items-center gap-2 mb-2">
                    {s.type === "airport" ? <Plane className="w-4 h-4 text-[#009900]" /> : <Store className="w-4 h-4 text-[#009900]" />}
                    <h3 className="font-bold text-[#0F1E17]">{s.name}</h3>
                  </div>
                  <p className="text-xs text-[#57685e] flex items-start gap-1.5"><MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {s.address}</p>
                  <p className="text-xs text-[#57685e] flex items-center gap-1.5 mt-1.5">
                    <Clock className="w-3.5 h-3.5" />
                    {s.hours.close === 24 ? t("Open 24 hours") : `${String(s.hours.open).padStart(2, "0")}:00 – ${String(s.hours.close).padStart(2, "0")}:00`}
                  </p>
                  {s.type === "airport" && <span className="inline-block mt-3 text-[10px] uppercase tracking-wide bg-[#FFDC00] text-[#0F1E17] font-semibold px-2 py-0.5 rounded">{t("Flight tracking available")}</span>}
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
